/**
 * v0-extension-detector.js
 * Video DownloadHelper等のブラウザ拡張を検出して警告を表示
 *
 * 作成日: 2025-12-02
 * ロールバック: このファイルを削除し、theme.liquidからscriptタグを削除するだけ
 */

(function() {
  'use strict';

  // 検出済みフラグ（1セッションに1回だけ警告）
  const STORAGE_KEY = 'verticaly_extension_warned';

  // 既に警告済みの場合はスキップ
  if (sessionStorage.getItem(STORAGE_KEY)) {
    return;
  }

  // 検出対象の拡張機能
  const EXTENSIONS = [
    {
      name: 'Video DownloadHelper',
      detect: () => {
        // Video DownloadHelperが注入するDOM要素やクラスを検出
        return document.querySelector('[class*="vdh"]') ||
               document.querySelector('[id*="vdh"]') ||
               document.querySelector('[class*="downloadhelper"]') ||
               document.querySelector('[id*="downloadhelper"]') ||
               window.hasOwnProperty('vdhCoappPort') ||
               window.hasOwnProperty('VdhCoappVersion');
      }
    },
    {
      name: 'SaveFrom.net Helper',
      detect: () => {
        return document.querySelector('[class*="savefrom"]') ||
               document.querySelector('[id*="savefrom"]') ||
               document.querySelector('.sfHelper') ||
               window.hasOwnProperty('savefrom_helper');
      }
    },
    {
      name: 'Video Downloader Professional',
      detect: () => {
        return document.querySelector('[class*="vdp-"]') ||
               document.querySelector('[id*="videodownloader"]') ||
               window.hasOwnProperty('VideoDownloaderPro');
      }
    },
    {
      name: 'Video Downloader Plus',
      detect: () => {
        return document.querySelector('[class*="vdplus"]') ||
               window.hasOwnProperty('vdplus');
      }
    },
    {
      name: 'Flash Video Downloader',
      detect: () => {
        return document.querySelector('[class*="fvd-"]') ||
               window.hasOwnProperty('FVDmedia');
      }
    }
  ];

  // 警告モーダルのHTML
  function createWarningModal(extensionName) {
    const modal = document.createElement('div');
    modal.id = 'verticaly-extension-warning';
    modal.innerHTML = `
      <style>
        #verticaly-extension-warning {
          position: fixed;
          top: 0;
          left: 0;
          width: 100%;
          height: 100%;
          background: rgba(0, 0, 0, 0.85);
          z-index: 999999;
          display: flex;
          align-items: center;
          justify-content: center;
          font-family: 'Helvetica Neue', Arial, sans-serif;
        }
        .vew-content {
          background: linear-gradient(135deg, #1a1a2e 0%, #16213e 100%);
          border-radius: 16px;
          padding: 40px;
          max-width: 500px;
          width: 90%;
          text-align: center;
          box-shadow: 0 20px 60px rgba(0, 0, 0, 0.5);
          border: 1px solid rgba(255, 255, 255, 0.1);
        }
        .vew-icon {
          font-size: 64px;
          margin-bottom: 20px;
        }
        .vew-title {
          color: #fff;
          font-size: 24px;
          font-weight: 600;
          margin-bottom: 16px;
        }
        .vew-message {
          color: rgba(255, 255, 255, 0.8);
          font-size: 15px;
          line-height: 1.7;
          margin-bottom: 24px;
        }
        .vew-extension-name {
          color: #ff6b6b;
          font-weight: 600;
        }
        .vew-button {
          background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);
          color: #fff;
          border: none;
          padding: 14px 40px;
          border-radius: 30px;
          font-size: 16px;
          font-weight: 600;
          cursor: pointer;
          transition: transform 0.2s, box-shadow 0.2s;
        }
        .vew-button:hover {
          transform: translateY(-2px);
          box-shadow: 0 10px 30px rgba(102, 126, 234, 0.4);
        }
        .vew-note {
          color: rgba(255, 255, 255, 0.5);
          font-size: 12px;
          margin-top: 20px;
        }
      </style>
      <div class="vew-content">
        <div class="vew-icon">⚠️</div>
        <div class="vew-title">警告</div>
        <div class="vew-message">
          <span class="vew-extension-name">${extensionName}</span> が検出されました。<br><br>
          無断でのダウンロード・再配布は利用規約違反となり、<br>
          法的手続きに移行します。
        </div>
        <button class="vew-button" onclick="document.getElementById('verticaly-extension-warning').remove()">
          了解しました
        </button>
        <div class="vew-note">
          ※ このメッセージはセッション中1回のみ表示されます
        </div>
      </div>
    `;
    return modal;
  }

  // 拡張機能を検出
  function detectExtensions() {
    for (const ext of EXTENSIONS) {
      try {
        if (ext.detect()) {
          console.log(`[Verticaly] Extension detected: ${ext.name}`);
          return ext.name;
        }
      } catch (e) {
        // 検出エラーは無視
      }
    }
    return null;
  }

  // video要素の監視（動的に追加される拡張UIを検出）
  function observeVideoElements() {
    const observer = new MutationObserver((mutations) => {
      if (sessionStorage.getItem(STORAGE_KEY)) {
        observer.disconnect();
        return;
      }

      const detected = detectExtensions();
      if (detected) {
        showWarning(detected);
        observer.disconnect();
      }
    });

    observer.observe(document.body, {
      childList: true,
      subtree: true,
      attributes: true,
      attributeFilter: ['class', 'id']
    });

    // 30秒後に自動停止（パフォーマンス対策）
    setTimeout(() => observer.disconnect(), 30000);
  }

  // 警告を表示
  function showWarning(extensionName) {
    if (sessionStorage.getItem(STORAGE_KEY)) return;

    sessionStorage.setItem(STORAGE_KEY, 'true');
    document.body.appendChild(createWarningModal(extensionName));
  }

  // 初期化
  function init() {
    // 即座に検出を試行
    const detected = detectExtensions();
    if (detected) {
      showWarning(detected);
      return;
    }

    // DOM変更を監視（拡張が遅延ロードする場合）
    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', observeVideoElements);
    } else {
      observeVideoElements();
    }
  }

  init();
})();
